import { ServerScaleSpecListInfo } from '@/api/type-server'

export class ScaleSpec {
  resID: string
  class: string
  createTime: Date
  enabled: boolean

  constructor(props: ServerScaleSpecListInfo) {
    this.resID = props.resID
    this.class = props.class
    this.createTime = new Date(props.createTime.seconds * 1000)
    this.enabled = props.enabled
  }
}
